import { DeleteIconButton } from '../../../common/buttons/DeleteIconButton';
import { OverviewReadButton } from '../../../common/buttons/OverviewReadButton/OverviewReadButton';
import { useRole } from '../../../common/hooks/useRole';
import { Box } from '../../../common/ui/Box';
import { getDeleteDraftConfirmPopupContent } from '../../common/deleteDraftConfirmPopupContent';
import { useOrderDelete } from '../../common/hooks/useOrderDelete';
import { OrderModel } from '../../model/OrderModel';

import { DraftActionsDropdownMenu } from './DraftActionsDropdwonMenu';
import { DuplicateOrderButton } from './DuplicateOrderButton';
import { useOrderMarkRead } from './useOrderMarkRead';

interface OrderActionsProps {
    order: OrderModel;
}

export const OrderActions = ({ order }: OrderActionsProps) => {
    const role = useRole();
    const { mutate: markRead } = useOrderMarkRead();
    const deleteOrderMutation = useOrderDelete();

    const onMarkRead = (order: OrderModel) => {
        markRead({ order, orderId: order.id, read: !order.read });
    };

    if (order.isDraft()) {
        if (role.isSuperAdmin()) {
            const deleteDraftContent = getDeleteDraftConfirmPopupContent(order.buyerReference);

            return (
                <DeleteIconButton
                    onDeleteConfirm={() => {
                        deleteOrderMutation.mutate(order.id);
                    }}
                    popupHeadline={deleteDraftContent.headline}
                    popupText={deleteDraftContent.text}
                    tooltip={deleteDraftContent.headline}
                />
            );
        }

        if (role.isCustomer() && role.hasWriteRights(order.customerId)) {
            return (
                <DraftActionsDropdownMenu
                    order={order}
                    onDeleteConfirm={deleteOrderMutation.mutate}
                    onMarkRead={onMarkRead}
                    isDeleting={deleteOrderMutation.isPending}
                />
            );
        }

        return null;
    }

    return (
        <Box display="flex" flexWrap="nowrap" columnGap={4}>
            {role.isCustomer() && role.hasWriteRights(order.customerId) ? (
                <OverviewReadButton onClick={() => onMarkRead(order)} isRead={order.read} />
            ) : null}

            {role.isCustomer() && role.hasWriteRights(order.customerId) ? <DuplicateOrderButton order={order} /> : null}
        </Box>
    );
};
